import { useFormContext } from 'react-hook-form'

import { SubmitInput } from '../baseInputs'

type Props = {
  children: string
  submitResponse: string
}

const Button = ({ children, submitResponse, ...rest }: Props) => {
  const {
    formState: { isSubmitting, isSubmitSuccessful },
  } = useFormContext()

  let celebrusID = ''
  if (submitResponse) {
    celebrusID = isSubmitSuccessful ? 'form-submit' : 'form-error'
  }

  return (
    <div className="flex space-x-4 items-center mt-10">
      <SubmitInput
        isSubmitting={isSubmitting}
        isSubmitSuccessful={isSubmitSuccessful}
        {...rest}
      >
        {children}
      </SubmitInput>
      {submitResponse && (
        <p id={celebrusID} className="font-medium">
          {submitResponse}
        </p>
      )}
    </div>
  )
}

export default Button
